<template>
  <div class="col-12 col-md-9 d-flex">
    <div class="card flex-grow-1">
      <h6 class="card-header">Inscriptions</h6>
      <div class="card-body position-relative">
        <BarHorizontalComponent
          bar-styles="height: 60px;"
          :data="datas"
          @click="itemOnClick"
        />
        <div class="small text-muted d-flex gap-3 flex-wrap">
          <div>Inscrit: <b>{{ inscrits }}</b></div>
          <div>Absents: <b>{{ refusals }}</b></div>
          <div>Non Inscrits: <b>{{ nonInscrits }}</b></div>

          <div class="ms-auto">Total Participants: <b>{{ totalParticipants }}</b><small v-if="companions.length > 0"> (dont {{ companions.length }} accompagnants)</small></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import * as ChartHelper from '@/compositions/chartHelper';
  import { computed } from 'vue';
  import { useBoardFilters } from '@/compositions/useBoardFilters';

  const { participations, filters, companions } = useBoardFilters({ applyStatus: false })

  const totalParticipants = computed(() => {
    return (participations.value.length ?? 0) + companions.value.length;
  });

  const inscrits = computed(() => {
    return (participations.value.filter(x=>x.invitation?.completionDate != null && x.invitation?.refusalDate == null).length ?? 0) + (companions.value.length ?? 0);
  });

  const refusals = computed(() => {
    return participations.value.filter(x=>x.invitation?.completionDate == null && x.invitation?.refusalDate != null).length ?? 0;
  });

  const nonInscrits = computed(() => {
    return participations.value.filter(x=>x.invitation?.completionDate == null && x.invitation?.refusalDate == null).length ?? 0;
  });

  const datas = computed(() => {
    return {
      labels: ["Participants"],
      datasets: [
        {
          label: "Inscrits",
          data: [inscrits.value],
          backgroundColor: [ChartHelper.Colors[0]],
          borderColor: [ChartHelper.Borders[0]],
        },
        {
          label: "Absents",
          data: [refusals.value],
          backgroundColor: [ChartHelper.Colors[1]],
          borderColor: [ChartHelper.Borders[1]],
        },
        {
          label: "Non Inscrits",
          data: [nonInscrits.value],
          backgroundColor: [ChartHelper.Colors[2]],
          borderColor: [ChartHelper.Borders[2]],
        }
      ]
    }
  });

  const itemOnClick = (label: string | undefined, value: number | [number, number] | undefined | null, index: number) => {
    if(filters) {
      switch(index) {
        case 0:
          filters.value.statusFilter = 'inscrit';
          break;
        case 1:
          filters.value.statusFilter = 'absent';
          break;
        case 2:
          filters.value.statusFilter = 'non-inscrit';
          break;
      }
    }
  };
</script>
